'use strict';
import {DataTagsCreateController} from './controllers/DataTagsCreateController';
import {DataTagsManageController} from './controllers/DataTagsManageController';
import {DataTagsManageTaggedController} from './controllers/DataTagsManageTaggedController';
import {DataTagDomainProvider} from './domain/DataTagDomain';
import {DataTagLinkDomainProvider} from './domain/DataTagLinkDomain';
import {DataTagsFilterService} from './filters/DataTagsFilterService';
import {DataTagsManageFilterService} from './filters/DataTagsManageFilter';
import {DataTagsManageTaggedFilterService} from './filters/DataTagsManageTaggedFilter';
import {DataTagMixin} from './services/DataTagMixin';
import {DataTagMixinFilter} from './services/DataTagMixinFilter';
import {DataTagsService} from './services/DataTagsService';

const angular = require('angular');

module.exports = angular
  .module('app.data-tags', [])

  .provider('DataTagDomain', DataTagDomainProvider)
  .provider('DataTagLinkDomain', DataTagLinkDomainProvider)

  .service('DataTagsFilterService', DataTagsFilterService)
  .service('DataTagsManageFilter', DataTagsManageFilterService)
  .service('DataTagsManageTaggedFilter', DataTagsManageTaggedFilterService)
  .service('DataTagMixin', DataTagMixin)
  .service('DataTagMixinFilter', DataTagMixinFilter)
  .service('DataTagsService', DataTagsService)

  .controller('DataTagsCreateController', DataTagsCreateController)
  .controller('DataTagsManageController', DataTagsManageController)
  .controller('DataTagsManageTaggedController', DataTagsManageTaggedController)
;



// WEBPACK FOOTER //
// ./src/js/data-tags/index.js